import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'wsb-email-create-editor',
  templateUrl: './email-create-editor.component.html',
  styleUrls: ['./email-create-editor.component.scss'],
  standalone: false
})
export class EmailCreateEditorComponent implements OnInit {
  constructor(private route: ActivatedRoute, private router: Router) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.router.navigate(['/mail/send'], { queryParams: { issue: params.issue } });
    });
  }
}
